import { useQuery } from 'react-query';
import axios from 'axios';

import { useAppDispatch } from '@app/store/hooks';
import { setUserIp } from '@features/profile/slices/ip.slice';

export const fetchMyIp = async (): Promise<string> => {
  const res = await axios.get('https://api.ipify.org/?format=json');
  return res.data.ip;
};

export function useMyIp() {
  const dispatch = useAppDispatch();

  useQuery(['user/ip'], fetchMyIp, {
    refetchOnWindowFocus: false,
    onSuccess(data) {
      dispatch(setUserIp(data));
    },
  });
}
